import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class MxUrlUtilsService {

    constructor() {
    }

    public constructUrlFromRoute(route: ActivatedRoute): string {
        return this.constructUrl(route.snapshot.data.restLink, route);
    }


    public constructUrl(restLink: string, route: ActivatedRoute): string {
        if (/(:(\w+[\.\w]+))/g.test(restLink)) {
            return restLink.replace(/(:(\w+[\.\w]+))/g, (matched) => {
                let currRoute = route;
                let paramPath: string[] = matched.slice(1).split('.');
                let currIndex = 0;
                while (paramPath.length > currIndex && currRoute[paramPath[currIndex]]) {
                    currRoute = currRoute[paramPath[currIndex++]];
                }
                if (currIndex === paramPath.length - 1
                    && paramPath[currIndex]
                    && currRoute.snapshot.params[paramPath[currIndex]] !== undefined) {
                    return currRoute.snapshot.params[paramPath[currIndex]];
                }
                console.error(`Can not find requested parameter: ${paramPath[currIndex]} for path: ${restLink}`);
                return matched;
            });
        } else {
            return restLink;
        }
    }
}
